import { useState, useEffect } from "react";
import "./loading-style.css";

const LOADING_LETTERS = ["L", "O", "A", "D", "I", "N", "G"];

const Loading = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setVisible(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (!visible) return null;

  return (
    <div className="yc-building-overlay">
      <div className="yc-building-stack" role="status" aria-label="Loading">
        <div className="yc-building-circle">
          <img
            className="yc-house-part yc-house-1"
            src="/images/house-1.png"
            alt=""
          />
          <img
            className="yc-house-part yc-house-2"
            src="/images/house-2.png"
            alt=""
          />
          <img
            className="yc-house-part yc-house-3"
            src="/images/house-3.png"
            alt=""
          />
        </div>
        <div className="yc-building-loading-text" aria-hidden="true">
          {LOADING_LETTERS.map((letter, index) => (
            <span
              key={index}
              className={`yc-building-loading-letter${
                letter === "." ? " yc-building-loading-dot" : ""
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {letter}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loading;
